var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIvaColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iva-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192.9 102.4",
    style: {
      enableBackground: "new 0 0 192.9 102.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003F84;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,25.8l-3.4,12.5H36.2l3.4-12.5C39.6,25.8,57.1,25.8,57.1,25.8z M34.9,43.1l-9.3,33.6h17.9l9-33.6H34.9z  M79.7,25.8H61.2l2.6,12.5h18.8L79.7,25.8z M94.3,43.1l-8,11.5l-2.7-11.5H64.7l6.6,32.4l0,0l0.3,1.4H90l1.3-1.6l26.9-32H94.3V43.1z  M107.4,25.9l-9,12.3h23.9l9.6-12.3C131.9,25.9,107.4,25.9,107.4,25.9z M156.6,25.6h-18.3l-10.7,12.5h31.5L156.6,25.6z M163,55.9 l-2.6-12.8h-35.8l-11.2,12.8h30.4l5.1,20.8h18.4L163,55.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIvaColor);
export default __webpack_public_path__ + "static/media/logo-iva-color.0836c550e1cad87f1d67cc5fd5d64abc.svg";
export { ForwardRef as ReactComponent };